import {
  DestroyRef,
  Injectable,
  inject
} from '@angular/core';

import {
  takeUntilDestroyed
} from '@angular/core/rxjs-interop';

import { AlertService } from '../../../../../core/services/alert.service';

import { InsightsQubeService } from '../../../../../core/services/insights-qube.service';

import { SharedService } from '../../../../../core/services/shared.service';

import { UploaderService } from '../../../../../core/services/uploader.service';

import { AddFilePayload } from '../../../insights-cube.model';

import { UploadWidgetService } from './upload-widget.service';
import { FolderValidationResult, UploadFileNode, UploadFolderNode } from '../upload-folder.model';
import { ResponseCode } from '../../../../../core/enums/responsecode.enum';

// ======================================================
// SERVICE
// ======================================================

@Injectable({
  providedIn: 'root'
})
export class SequentialUploadService {

  // ======================================================
  // INJECT
  // ======================================================

  private readonly insQubeSrv = inject(InsightsQubeService);

  private readonly destroyRef = inject(DestroyRef);

  private readonly uploaderService = inject(UploaderService);

  private readonly alertService = inject(AlertService);

  private readonly sharedService = inject(SharedService);

  private readonly uploadWidgetService = inject(UploadWidgetService);

  // ======================================================
  // PERFORMANCE TRACKING
  // ======================================================

  private uploadStartTime = 0;

  private totalFiles = 0;

  private uploadedFiles = 0;

  // ======================================================
  // VARIABLE
  // ======================================================

  private currentJobId = '';


  // ======================================================
  // ENTRY POINT
  // ======================================================

  async processTree(
    folders: UploadFolderNode[],
    folderId: number|undefined = undefined,
    validationResult: FolderValidationResult
  ): Promise<void> {

    // ================================================
    // PERFORMANCE START
    // ================================================

    this.uploadStartTime =
      performance.now();

    this.totalFiles =
      this.countTotalFiles(folders);

    this.uploadedFiles = 0;

    console.log(
      '======================================'
    );

    console.log(
      'FOLDER UPLOAD STARTED'
    );

    console.log({
      totalFolders:
        this.countTotalFolders(folders),

      totalFiles:
        this.totalFiles
    });

    console.log(
      '======================================'
    );

    const jobId =
  crypto.randomUUID();

this.currentJobId =
  jobId;

this.uploadWidgetService.addJob({
  id: jobId,
  name: folders[0]?.name ?? 'Folder Upload',
  totalFiles: this.totalFiles,
  uploadedFiles: 0,
  failedFiles: 0,
  progress: 0,
  status: 'running',
  startedAt: new Date(),
  failedItems: [],
  createdFolders: [],
  createdFileIds: [],
  skippedFiles: validationResult.skippedFilesCount
});

    // ================================================
    // PROCESS TREE
    // ================================================

    for (const folder of folders) {

      try {
      await this.processFolder(
        folder,
        folderId
      );
      //if fatal error returns
        const job =
          this.uploadWidgetService
            .jobs()
            .find(
              x => x.id === this.currentJobId
            );

        if (
          job?.fatalError
        ) {

          return;
        }
      } catch (err: any) {
        if (
          err?.error?.code ===
          'RecordAlreadyExists'
        ) {

          this.uploadWidgetService
            .markJobFailed(
              this.currentJobId,
              'Folder already exists.',
              true
            );

          return;
        }

        this.uploadWidgetService
          .markJobFailed(
            this.currentJobId,
            'Unable to create root folder.',
            true
          );

        return;
      }
    }

    // ================================================
    // PERFORMANCE END
    // ================================================

    const totalTimeMs =
      performance.now() -
      this.uploadStartTime;

    const totalTimeSeconds =
      (totalTimeMs / 1000)
        .toFixed(2);

    console.log(
      '======================================'
    );

    console.log(
      'FOLDER UPLOAD COMPLETED'
    );


    console.log({

      uploadedFiles:
        this.uploadedFiles,

      totalFiles:
        this.totalFiles,

      totalTimeMs:
        Math.round(totalTimeMs),

      totalTimeSeconds:
        `${totalTimeSeconds}s`
    });

    console.log(
      '======================================'
    );

    // UPDATE UPLOADWIDGETSERVICE
//     this.uploadWidgetService.updateJob(
//   this.currentJobId,
//   job => ({

//     ...job,

//     status:
//       job.failedFiles
//         ? 'failed'
//         : 'completed',

//     completedAt:
//       new Date(),

//     progress: 100
//   })
// );

    const currentJob =
      this.uploadWidgetService
        .jobs()
        .find(
          x => x.id === this.currentJobId
        );

    if (
      currentJob?.status === 'failed'
      ||
      currentJob?.status === 'cancelled'
    ) {

      return;
    }

    this.uploadWidgetService.updateJob(
      this.currentJobId,
      job => ({

        ...job,

        status: this.uploadWidgetService.calculateStatus(job.uploadedFiles, job.failedFiles, job.skippedFiles, job.totalFiles),

        completedAt: new Date(),

        progress: 100
      })
    );


this.uploadWidgetService.uploadCompleted.set({timestamp: Date.now()});

// this.uploadWidgetService.startAutoClose(this.currentJobId);

    this.alertService.success(
      `Folder upload completed in ${totalTimeSeconds}s`
    );
  }

  // ======================================================
  // PROCESS FOLDER
  // ======================================================

  private async processFolder(
    folder: UploadFolderNode,
    parentFolderId?: number
  ): Promise<any> {

    try {

      
      //CHECk CANCELLETIONS
      this.checkCancellation();

      folder.status =
        'creating-folder';

      console.log(
        `Creating folder: ${folder.relativePath}`
      );

      // ================================================
      // CREATE FOLDER
      // ================================================

      const folderResponse =
        await this.createFolder(
          folder.name,
          parentFolderId
        );

      folder.backendFolderId =
        folderResponse.id;

      // push newly created folder id for later use for processing
      // this.createdFolders.push({
      //   id: folderResponse.id,
      //   name: folder.name,
      //   relativePath: folder.relativePath,
      //   parentId: parentFolderId
      // });

  this.uploadWidgetService.updateJob(
  this.currentJobId,
  job => ({
    ...job,
createdFolders: [
  ...job.createdFolders.filter(
    x =>
      x.id !==
      folderResponse.id
  ),
  {
    id: folderResponse.id,
    name: folder.name,
    relativePath: folder.relativePath,
    parentId: parentFolderId
  }
]
  })
);

      folder.parentFolderId =
        parentFolderId;

      folder.status =
        'completed';

      console.log(
        `Folder created: ${folder.relativePath}`
      );

      // ================================================
      // UPLOAD FILES
      // ================================================

      for (const file of folder.files) {

        await this.processFile(
          file,
          folder.backendFolderId
        );
      }

      // ================================================
      // PROCESS SUB FOLDERS
      // ================================================

      for (const subFolder of folder.folders) {

        try {
          await this.processFolder(
            subFolder,
            folder.backendFolderId
          );
        } catch (err) {
          this.uploadWidgetService
            .markJobFailed(
              this.currentJobId,
              `
      Subfolder creation failed.

      Delete partially created
      root folder and retry.
      `,
              true
            );

          throw new Error(
            'SUB_FOLDER_FAILED'
          );
        }

      }

    } catch (error) {

      // console.error(
      //   'Folder creation failed',
      //   folder.name,
      //   error
      // );

      folder.status =
        'failed';

        throw error;
    }

  }

  // ======================================================
  // PROCESS FILE
  // ======================================================

  private async processFile(
    file: UploadFileNode,
    folderId?: number
  ): Promise<void> {

    try {

      //check CANCELLETION
      this.checkCancellation();

      file.status =
        'uploading';

      file.parentFolderId =
        folderId;

      console.log(
        `Uploading file: ${file.relativePath}`
      );

      const fileStartTime =
        performance.now();

      const response =
        await this.uploadFile(
          file,
          folderId
        );

        console.log({"ProcessFile:": response})

      const fileEndTime =
        performance.now();

      const fileTime =
        (
          (fileEndTime - fileStartTime) / 1000
        ).toFixed(2);

      file.backendFileId = response.id;

this.uploadWidgetService.updateJob(
  this.currentJobId,
  job => ({
    ...job,
    createdFileIds: [
  ...new Set([
    ...job.createdFileIds,
    response.id
  ])
]
  })
);

      file.progress = 100;

      file.status =
        'completed';

      this.uploadedFiles++;

      console.log({
        uploaded:
          this.uploadedFiles,

        total:
          this.totalFiles,

        file:
          file.relativePath,

        uploadTime:
          `${fileTime}s`
      });

      //Update UploadwidgetService
      this.uploadWidgetService.updateJob(
        this.currentJobId,
        job => ({

          ...job,

          failedItems:
            job.failedItems.filter(
              item =>
                item.file.id !== file.id
            ),

          failedFiles:
            Math.max(
              0,
              job.failedFiles -
              (
                job.failedItems.some(
                  item =>
                    item.file.id === file.id
                )
                  ? 1
                  : 0
              )
            ),

          uploadedFiles:
            job.uploadedFiles + 1,

          progress:
            Math.round(
              (
                (job.uploadedFiles + 1)
                /
                job.totalFiles
              ) * 100
            )
        })
      );

    } catch (error: any) {

      console.error(
        'File upload failed',
        file.name,
        error
      );
      file.status ='failed';

      //Update UploadWidgetService
this.uploadWidgetService.updateJob(
  this.currentJobId,
  job => {

    const alreadyExists =
      job.failedItems.some(
        item =>
          item.file.id === file.id
      );

    return {

      ...job,

      failedFiles:
        alreadyExists
          ? job.failedFiles
          : job.failedFiles + 1,

      failedItems:
        alreadyExists
          ? job.failedItems
          : [
              ...job.failedItems,
              {
                file,
                reason:
                  error
                    ? error?.error?.message
                    : 'Upload failed',
                retryAllowed:
                  !!file.parentFolderId && (error?.error?.code != ResponseCode.InvalidFileType && error?.error?.code != ResponseCode.InvalidRequestFormat)
              }
            ]
    };
  }
);
    }
  }

  // ======================================================
  // CREATE FOLDER
  // ======================================================

  private async createFolder(
    name: string,
    parentId?: number
  ): Promise<any> {

    //CHECK CANCELLETION
    this.checkCancellation();

    const payload: AddFilePayload = {

      is_directory: true,

      name,

      upload_id: '',

      parent_dir_id:
        parentId || null
    };

    return new Promise((resolve, reject) => {

      this.insQubeSrv
        .createDirectory(payload)
        .pipe(
          takeUntilDestroyed(
            this.destroyRef
          )
        )
        .subscribe({

          next: (res: any) => {

            resolve(res.data);
          },

          error: (error) => {

            console.error(error);

            reject(error);
          }
        });
    });
  }

  // ======================================================
  // FILE UPLOAD
  // ======================================================

  private async uploadFile(
    file: UploadFileNode,
    folderId?: number
  ): Promise<any> {

    return await this.uploadSingleFile(
      file,
      folderId
    );
  }

  // ======================================================
  // SINGLE FILE UPLOAD
  // ======================================================

  // private async uploadSingleFile(
  //   fileNode: UploadFileNode,
  //   parentDirId?: number
  // ): Promise<any> {

  //   return new Promise<any>((resolve, reject) => {

  //     try {

  //       fileNode.status =
  //         'uploading';

  //       fileNode.progress = 0;

  //       const reader =
  //         new FileReader();

  //       reader.readAsArrayBuffer(
  //         fileNode.file
  //       );

  //       const sanitizedFileName =
  //         fileNode.name.replace(
  //           /[!#^$%\/\\<>|\*"\?:&]/g,
  //           ''
  //         );

  //       const successCb =
  //         async (data: any) => {

  //           try {

  //             if (data?.uploadId) {

  //               const response =
  //                 await this.addFile(
  //                   parentDirId,
  //                   sanitizedFileName,
  //                   data.uploadId,
  //                   fileNode
  //                 );

  //               fileNode.progress = 100;

  //               fileNode.status =
  //                 'completed';

  //               resolve(response);

  //             } else {

  //               fileNode.status =
  //                 'failed';

  //               reject();
  //             }

  //           } catch (error) {

  //             fileNode.status =
  //               'failed';

  //             reject(error);
  //           }
  //         };

  //       const errorCb = () => {

  //         fileNode.status =
  //           'failed';

  //         this.alertService.error(
  //           'File upload failed.'
  //         );

  //         reject();
  //       };

  //       reader.onload =
  //         async () => {

  //           try {

  //             if (!reader.result) {

  //               reject();

  //               return;
  //             }

  //             const blob =
  //               new Blob(
  //                 [reader.result],
  //                 {
  //                   type: fileNode.type
  //                 }
  //               );

  //             await this
  //               .uploaderService
  //               .beginVideoUpload(

  //                 this
  //                   .sharedService
  //                   .plugins
  //                   .uuid
  //                   .v4(),

  //                 blob,

  //                 {},

  //                 successCb,

  //                 errorCb,

  //                 sanitizedFileName,

  //                 true,

  //                 // ====================================
  //                 // PROGRESS CALLBACK
  //                 // ====================================

  //               //   (
  //               //     progress: number
  //               //   ) => {

  //               //     fileNode.progress =
  //               //       Math.round(progress);
  //               //   }
  //               );

  //           } catch (error) {

  //             reject(error);
  //           }
  //         };

  //     } catch (error) {

  //       reject(error);
  //     }
  //   });
  // }

  private async uploadSingleFile(
  fileNode: UploadFileNode,
  parentDirId?: number
): Promise<any> {

  return new Promise<any>(
    (resolve, reject) => {

      try {

        fileNode.status =
          'uploading';

        fileNode.progress = 0;

        const sanitizedFileName =
          fileNode.name.replace(
            /[!#^$%\/\\<>|\*"\?:&]/g,
            ''
          );

        const successCb =
          async (
            data: any
          ) => {

            try {

              if (
                data?.uploadId
              ) {

                const response =
                  await this.addFile(
                    parentDirId,
                    sanitizedFileName,
                    data.uploadId,
                    fileNode
                  );

                resolve(
                  response
                );

              } else {

                reject(data);
              }

            } catch (
              error
            ) {

              reject(error);
            }
          };

        const errorCb =
          (err: any) => {
            console.log({"uploadSingleFile beginVideoUpload Err:": err})
            reject(err);
          };

        this
          .uploaderService
          .beginVideoUpload(

            this
              .sharedService
              .plugins
              .uuid
              .v4(),

            fileNode.file, // IMPORTANT

            {},

            successCb,

            errorCb,

            sanitizedFileName,

            true
          );

      } catch (error) {

        reject(error);
      }
    }
  );
}

  // ======================================================
  // ADD FILE
  // ======================================================

  private addFile(
    parentDirId: number | undefined,
    fileName: string,
    uploadId: string,
    fileNode: UploadFileNode
  ): Promise<any> {

    return new Promise((resolve, reject) => {

      const payload: AddFilePayload = {

        parent_dir_id:
          parentDirId ?? null,

        name: fileName,

        upload_id: uploadId,

        is_directory: false
      };

      this.insQubeSrv
        .createDirectory(payload)
        .subscribe({

          next: (res: any) => {

            fileNode.backendFileId =
              res?.data?.id;

            fileNode.status =
              'completed';

            resolve(res?.data);
          },

          error: (err) => {

            fileNode.status =
              'failed';

            fileNode.progress = 0;

            this.alertService
              .defaultErrorMessageHandler(err);

            reject(err);
          }
        });
    });
  }

  // ======================================================
  // HELPERS
  // ======================================================

  private countTotalFiles(
    folders: UploadFolderNode[]
  ): number {

    let total = 0;

    for (const folder of folders) {

      total +=
        folder.files.length;

      if (
        folder.folders.length
      ) {

        total +=
          this.countTotalFiles(
            folder.folders
          );
      }
    }

    return total;
  }

  private countTotalFolders(
    folders: UploadFolderNode[]
  ): number {

    let total = 0;

    for (const folder of folders) {

      total++;

      if (
        folder.folders.length
      ) {

        total +=
          this.countTotalFolders(
            folder.folders
          );
      }
    }

    return total;
  }


  async retryFile(
  file: UploadFileNode
): Promise<void> {

  if (
    !file.parentFolderId
  ) {
    return;
  }

  await this.processFile(
    file,
    file.parentFolderId
  );
}

private checkCancellation(): void {

  if (
    this.uploadWidgetService
      .isCancelled(
        this.currentJobId
      )
  ) {

    throw new Error(
      'UPLOAD_CANCELLED'
    );
  }
}

}